<template>
  <div class="">
    <a-row :gutter="[16, 16]">
      <a-col :span="20">
        <a-form :colon="false" id="check" :form="form" v-bind="formItemLayout" ref="tradeForm">
          <a-form-item label="论文题目">
            <a-input :placeholder="$store.state.check.fieldsValue.title" :maxLength="50" disabled />
          </a-form-item>
          <a-form-item label="选择检测库" class="form-img">
            <div class="pro_logo">
              <img src="@/assets/images/wf_logo_product.png" />
              <span>{{ $store.state.check.choosedPrd.productName }}</span>
            </div>
          </a-form-item>
          <a-form-item label="支付方式" class="form-img">
            <div>
              <a-radio-group @change="onChange" 
                v-decorator="[
                  'payType',
                  {
                    rules: [{ required: true, message: '请选择支付方式!' }],
                  },
                ]"
              >
                <a-radio :value="'WEIXIN'" v-if="$store.state.check.activeObj.useWx === 'Y'">
                  <span><img src="../assets/images/wxzf.png" /></span>
                </a-radio>
                <a-radio :value="'ALIPAY'" v-if="$store.state.check.activeObj.useAli === 'Y' ">
                  <span><img src="../assets/images/zfb.png" /></span>
                </a-radio>
                <a-radio :value="'OFFICIAl'" v-if="$store.state.check.activeObj.haveWeChatOfficial === 'Y' ">
                  <span>公众号支付</span>
                </a-radio>
              </a-radio-group>
            </div>
          </a-form-item>
          <a-form-item label="论文总字数">
            <a-input v-if="$store.state.check.tabKey==='1'" :placeholder="$store.state.check.fileCount" :maxLength="50" disabled />
            <a-input v-if="$store.state.check.tabKey==='2'" :placeholder="$store.state.check.inputCount" :maxLength="50" disabled />
          </a-form-item>
          <!-- <a-form-item style="text-align: left" label="订单金额">
            <a-input :value="result[0] && result[0].amount" :maxLength="50" disabled />
          </a-form-item>
          <a-form-item style="text-align: left" label="优惠券金额">
            <a-input :value="couponPrice" :maxLength="50" disabled />
          </a-form-item> -->
          <a-form-item style="text-align: left" label="应付金额">
            <a-input :value="result[0] && result[0].amount" :maxLength="50" disabled />
            <a-alert message="购买后请保存订单，以便日后查询。" banner />
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    
    <a-modal
      class="payModal"
      v-model="visible"
      :footer="null"
      :width="300"
      @cancal="handleCancle"
      centered>
      <div class="bodyer">
        <div class="tit2">
          <h6 v-if="value === 'WEIXIN'">微信扫码支付</h6>
          <h6 v-if="value === 'ALIPAY'">支付宝扫码支付</h6>
          <h6 v-if="value === 'OFFICIAl'">公众号支付</h6>
          <p>手机扫一扫进行付款</p>
        </div>
        <div class="qr-place qrmargin">
          <div>
            <div v-if="value!=='OFFICIAl'" ref="qrcode">
              <a-spin />
            </div>
            <a-spin v-if="value==='OFFICIAl' && qrurl === null" />
            <img v-if="value==='OFFICIAl' && qrurl !== null" :src="qrurl" width="220px" height="220px" />
          </div>
          <div v-if="value!=='OFFICIAl' && timeOut" class="">
            <div class="tranmb"></div>
            <!-- <div style="opacity: 0">{{qrurl}}</div> -->
            <div class="qr-cont">
              <img src="../assets/images/error.png">
              <p class="txt">二维码已过期，请 <a href="javascript:;" @click="$emit('refreshqrcode')">刷新</a></p>
            </div>
          </div>
        </div>

        <!-- <p style="margin-bottom:16px;text-align:center" class="ng-binding">订单号:A2004787424190466613</p> -->
        <div class="qr-foot" @click="handleCancle">返回</div>
      </div>

      <!-- <div v-if="value === 'WEIXIN'">微信扫码支付</div>
      <div v-if="value === 'ALIPAY'">支付宝扫码支付</div>
      <div ref="qrcode">
        <a-spin />
      </div>
      <div class="ng-scope" :style="{display: timeOut?  'block' : 'none'} ">
        <div class="tranmb"></div>
        <div style="opacity: 0">{{qrurl}}</div>
        <div class="qr-cont">
          <img src="../assets/images/error.png">
          <p class="txt">二维码已过期，请 <a href="javascript:;" @click="$emit('refreshqrcode')">刷新</a></p>
        </div>
      </div> -->
    </a-modal>
  </div>
</template>

<script>
import { Row, Col, Form, Input, Radio, Alert, Modal, Spin } from 'ant-design-vue'
import QRCode from 'qrcodejs2'
export default {
  name: 'Pay',
  components: {
      AAlert:Alert,
      ARadio:Radio,
      ARadioGroup:Radio.Group,
      ARow: Row,
      ACol: Col,
      // ACard: Card,
      // AIcon: Icon,
      AForm: Form,
      AFormItem: Form.Item,
      AInput: Input,
      AModal: Modal,
      ASpin: Spin,
      // ATextarea: Input.TextArea,
      // ATabs: Tabs,
      // ATabPane: Tabs.TabPane,
      // AButton: Button,
      // AUpload: Upload,
      // ADatePicker: DatePicker,
      // DictSelect,
      // DictAuto,
  },
  props:{
    tradeId:{
      type:String,
      default: undefined
    }
  },
  data (){
    return{
    formItemLayout: {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    },
    formItemLayout1: {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    },
    // value: 1,
    // tradeId: this.ParentTradeId || undefined,
    result: [],
    // columns,
    value: this.getValue(),
    visible: false, 
    timeOut: false,
    qrurl: null,
    // couponPrice:0,
    }
  },
  beforeCreate() {
      this.form = this.$form.createForm(this, { name: 'payform' })
      // this.couponform = this.$form.createForm(this, { name: 'couponform'})
    },
  created() {
    if(this.tradeId) {
      this.$store.dispatch('check/getTradeById', {
        payload: {
          tradeId:this.tradeId
        },
        callback: (res) => {
          this.result = [res]
        }
      })
    }
  },
  methods: {
    getValue() {
      if(this.$store.state.check.activeObj.useWx === 'Y'){
        this.value = 'WEIXIN'
      }else if (this.$store.state.check.activeObj.useWx === 'Y')
      {
        this.value = 'ALIPAY'

      }else if(this.$store.state.check.activeObj.haveWeChatOfficial === 'Y'){
        this.value = 'OFFICIAl'
      }else{
        this.value = 'TMALL'
      }  
    },
    creatQrCode() {
      const canvas = this.$refs.qrcode
      new QRCode(canvas, {
        width: 220,
        height: 220, // 高度
        text: this.qrurl // 二维码内容
      })
      setTimeout(() => this.timeOut = true, 60000 * 3)
      setTimeout( this.checkPay, 2000)
    },
    handleCancle() {
      this.visible = false
    },
    onChange(e) {
      this.value = e.target.value
    },
    checkPay () {
      if(!this.visible) return
      this.$store.dispatch('check/requests', {
        payload: {
          tradeId: this.tradeId
        },
        callback: (res) => {
          if(res.success && res.data.payState && res.data.payState === 'PAID') {
            this.visible = false
            res.data.transactionId && this.$router.push({path:`/down/${res.data.transactionId}`})
          } else {
            setTimeout( this.checkPay, 2000)
          }
        }
      })
    },
    // couponSubmit(e) {
    //   e.preventDefault();
    //   this.couponform.validateFields((err, values) => {
    //     if (err) {
    //       return;
    //     }
    //     console.log(this.tradeId)
    //     this.$store.dispatch('check/redeemCoupon', {
    //       payload: {
    //         ...values,
    //         tradeId: this.tradeId,
    //       },
    //       callback: (res) => {
    //         if(res.success){
    //           message.success("优惠券兑换成功！")
    //           this.useCoupon = true;
    //           this.couponPrice = res.data.couponPrice;
    //           //this.cashFee = res.data.cashFee;
    //           this.afterConponAmount = res.data.cashFee
    //         }
    //       }
    //     })
    //   })
    // },
  }
}
</script>

<style lang="less" scoped>
.form-img {
  text-align: left;
  img {
    margin-right: 10px;
  }
}
.ant-input[disabled] {
  color: red;
  background-color: #f5f5f5;
}
.pro_logo {
  width:243px;
  height:50px;
  line-height:50px;
  background-color: #093D7C;
  border-radius:5px;
  text-align: center;
  img {
    margin: 5px 10px 12px 0;
  }
  span {
    font-size:20px;
    color:#fff;
  }
}


.payModal  {
  box-shadow: 0 0 10px #d2d2d2;
}
.payModal .icon-close {
    width: 15px;
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 15px;
}
.payModal .tit2 {
  text-align: center;
}
.payModal .tit2 h6 {
    padding-top: 10px;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 3px;
}
.payModal .qr-place.qrmargin {
    margin-top: 20px;
    margin-bottom: 20px;
}
.payModal .qr-place {
    position: relative;
    text-align: center;
    width: 220px;
    height: 220px;
    margin: 0 auto;
}
.payModal .qr-place img.erweima {
    max-width: 100%;
    max-height: 100%;
}
.payModal .tranmb {
    background-color: #1d1d1d;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: .62;
}
.payModal .qr-place .qr-cont {
    position: absolute;
    left: 0px;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    margin-top: 30%;
    text-align: center;
}
.payModal .qr-place .qr-cont .txt {
    color: #fff;
}
.payModal .qr-place .qr-cont a {
    color: #fff;
    text-decoration: underline;
}
.payModal .qr-foot {
    background-color: #f5f5f5;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
}
</style>
